import React from 'react';
import { Tint, Wrapper } from './Palette.style';

export type PaletteProps = {
  tints: string[];
};

export function Palette(props: PaletteProps) {
  const { tints } = props;

  function renderTint(tint: string, index: number) {
    const style: React.CSSProperties = {
      backgroundColor: tint,
    };

    return <Tint key={index} style={style} className='tint'></Tint>;
  }

  function renderTints() {
    return tints.map((tint: string, index) => renderTint(tint, index));
  }

  return (
    <Wrapper className='Palette-wrapper' data-testid='Palette-wrapper'>
      {renderTints()}
    </Wrapper>
  );
}

export default Palette;
